import { useEffect } from 'react';

export default function RedirectToStore() {
  useEffect(() => {
    function redirectToStore() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isAndroid = /android/i.test(userAgent);
      const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      const isWindows = /Win/i.test(userAgent);
      const isMac = /Mac/i.test(userAgent);

      if (isAndroid) {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.guilu.appresolvaclub';
      } else if (isIOS) {
        window.location.href =
          'https://apps.apple.com/br/app/resolva-arm%C3%A1rio-digital/id1575252378';
      } else if (isWindows) {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.guilu.appresolvaclub';
      } else if (isMac) {
        window.location.href =
          'https://apps.apple.com/br/app/resolva-arm%C3%A1rio-digital/id1575252378';
      } else {
        console.warn(
          'Sistema operacional não identificado. Por favor, acesse a loja de aplicativos manualmente.'
        );
      }
    }

    redirectToStore();
  }, []);

  return null;
}
